import { ObjectID } from 'bson';
import { Schema } from 'mongoose';
import { arrayMaxLengthValidator } from '../common-validators';
import { MAX_NUMBER_OF_NOTES } from '../constants';
import cancellationPolicy, { ICancellationPolicy } from './cancellationPolicy';
import Instructions, { IInstruction } from './instructions';
import LocalizedField, { ILocalizedText } from './localized-text';
import servicePriceSchema, { ServicePrice } from './service-price';

export interface ISelectedOption {
  availabilityCode?: string;
  price: ServicePrice;
  title: ILocalizedText;
  subtitle?: ILocalizedText;
  roomType?: ILocalizedText;
  mealType?: ILocalizedText;
  cancellable: boolean;
  cancellationPolicies?: ICancellationPolicy[];
}
const selectedOption = new Schema(
  {
    availabilityCode: { type: String },
    price: { type: servicePriceSchema },
    title: { type: LocalizedField },
    subtitle: { type: LocalizedField },
    roomType: { type: LocalizedField },
    mealType: { type: LocalizedField },
    cancellable: {
      type: Boolean,
      default() {
        const { cancellationPolicies } = this as ISelectedOption;
        if (cancellationPolicies && cancellationPolicies.length > 0) return true;
        return false;
      },
    },
    cancellationPolicies: { type: [cancellationPolicy] },
  },
  { _id: false },
);

export interface IServiceOrganization {
  _id: ObjectID;
  service: ObjectID;
  day: number;
  time?: number;
  priority: number;
  instructions: IInstruction;
  notes: ILocalizedText[];
  externallyBooked?: boolean;
  selectedOption?: ISelectedOption;
}
const serviceOrganization = new Schema({
  service: {
    type: Schema.Types.ObjectId,
    ref: 'Service',
    required: true,
  },
  day: {
    type: Number,
    required: true,
    min: 1,
  },
  time: {
    type: Number,
    required: false,
    min: 0,
    max: 23.5,
  },
  priority: {
    type: Number,
    required: true,
    default: 1,
    min: 1,
  },
  instructions: {
    type: Instructions,
  },
  notes: {
    type: [LocalizedField],
    required: true,
    default: [],
    validate: arrayMaxLengthValidator(MAX_NUMBER_OF_NOTES),
  },
  externallyBooked: { type: Boolean },
  selectedOption,
});

export default serviceOrganization;
